import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Row from '../../Row';
import Col from '../../Col';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';

import Input from '../../Input';
import Checkbox from '../../Checkbox';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../SignatureCanvas/SignatureCanvas.scss';
import SignatureCanvas from '../../SignatureCanvas';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import { selectEasyWalkThroughFormData } from '../../../store/selectors/easyWalkThroughForm';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { setEasyWalkThroughFormData } from '../../../store/actions/easyWalkThroughForm';
import { setPropertyWalkThroughFormData } from '../../../store/actions/propertyWalkThroughForm';
import Overlay from '../../Overlay';
import ServiceRequestEditForm from './ServiceRequestEditForm';
import {
  fetchServiceRequestById,
  clearServiceRequestDone,
  fetchServiceRequestByIdDone,
} from '../../../store/actions/serviceRequest';
import Loader from '../../Loader';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import { deleteServiceRequest } from '../../../store/actions/serviceRequests';
import Avatar from '../../Avatar';
import { fetchAreasAndSubAreas } from '../../../store/actions/areas';
import { fetchServiceRequestTags } from '../../../store/actions/formOptions';

class CompleteWalkthrough extends Component {
  state = {
    showAddForm: false,
    firstName: '',
    lastName: '',
    role: '',
    email: '',
    atFirstOnly: true,
    serviceRequest: null,
    returnFromEditServiceRequest: false,
    walkThroughSignatureList: [],
    copied: true,
    selectedImages: [],
    showImages: false,
  };

  componentDidMount() {
    const {
      easyWalkThroughFormData,
      onSetEasyWalkThroughFormData,
      propertyWalkThroughFormData,
    } = this.props;
    const {
      homeOwnerFirstName,
      homeOwnerLastName,
      propertyManagerFirstName,
      propertyManagerLastName,
    } = easyWalkThroughFormData;
    let mandatorySigns = [];
    if (propertyWalkThroughFormData.status === 'In Progress Home Only') {
      mandatorySigns = [
        {
          email: null,
          firstName: homeOwnerFirstName,
          lastName: homeOwnerLastName,
          role: 'Home Owner',
          signType: '',
          signature: '',
        },
      ];
    } else {
      if (
        propertyWalkThroughFormData.walkthroughType ===
          'Home Owner Walk-through' ||
        (propertyWalkThroughFormData.walkthroughType === 'Enhanced' &&
          propertyWalkThroughFormData.permissions === 'Homeowner or Occupant' &&
          propertyWalkThroughFormData.isHomeOwner === true)
      ) {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
          {
            email: null,
            firstName: homeOwnerFirstName,
            lastName: homeOwnerLastName,
            role: 'Home Owner',
            signType: '',
            signature: '',
          },
        ];
      } else {
        mandatorySigns = [
          {
            email: null,
            firstName: propertyManagerFirstName,
            lastName: propertyManagerLastName,
            role: 'Property Developer',
            signType: '',
            signature: '',
          },
        ];
      }
    }
    this.setState({ walkThroughSignatureList: mandatorySigns });
  }

  addOne() {
    const { easyWalkThroughFormData } = this.props;
    let signatures =
      easyWalkThroughFormData.walkThroughSignatureList &&
      easyWalkThroughFormData.walkThroughSignatureList.length > 0
        ? easyWalkThroughFormData.walkThroughSignatureList
        : [];
    let addSignee = [
      {
        button: 'Add Signee',
      },
    ];
  }

  handleSignature(image, signType, index, data, type) {
    const { firstName, lastName, role, email, walkThroughSignatureList } =
      this.state;
    if (image !== null) {
      let signatures =
        walkThroughSignatureList && walkThroughSignatureList.length > 0
          ? walkThroughSignatureList
          : [];
      let obj = {};
      if (type && type === 'AddNewSignee') {
        obj = {
          email,
          firstName,
          lastName,
          role,
          signType,
          signature: image,
        };
        this.setState({
          firstName: '',
          lastName: '',
          role: '',
          email: '',
          showAddForm: false,
        });
      } else {
        obj = data;

        obj = {
          ...obj,
          signature: image,
          signType: signType,
        };
      }
      let signs = [];
      if (signatures.length > 0) {
        let objExists = signatures[index] ? true : false;
        if (objExists === true) {
          signs = signatures.map((data, i) => {
            if (i === index) {
              return obj;
            } else {
              return data;
            }
          });
        } else {
          signs = [...signatures, ...[obj]];
        }
      } else {
        signs = [obj];
      }

      // onSetEasyWalkThroughFormData({ walkThroughSignatureList: signs })
      this.setState({ walkThroughSignatureList: signs });
    } else {
      toast.error('🚫 Please enter a valid signature.', {
        autoClose: 10000,
        position: 'top-center',
      });
    }
  }

  disableButton() {
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    if (signatures.length > 0) {
      let disable = false;
      signatures.map((sign) => {
        if (sign.signature === null || sign.signature === '') {
          disable = true;
        }
      });

      return disable;
    } else {
      return true;
    }
  }

  signatures() {
    const { easyWalkThroughFormData, propertyWalkThroughFormData, user } =
      this.props;
    const {
      homeOwnerFirstName,
      homeOwnerLastName,
      propertyManagerFirstName,
      propertyManagerLastName,
    } = easyWalkThroughFormData;
    const { walkThroughSignatureList } = this.state;
    let signatures =
      walkThroughSignatureList && walkThroughSignatureList.length > 0
        ? walkThroughSignatureList
        : [];
    let mandatorySigns = [];

    mandatorySigns = [...signatures, ...[{ button: 'Add Signee' }]];

    return mandatorySigns;
  }

  handleSubmit() {
    const { easyWalkThroughFormData, handleCompleteWalkThrough } = this.props;
    const { walkThroughSignatureList } = this.state;
    handleCompleteWalkThrough(walkThroughSignatureList);
  }

  removeSignature(data, index) {
    const {
      easyWalkThroughFormData,
      handleCompleteWalkThrough,
      onSetEasyWalkThroughFormData,
    } = this.props;
    const { walkThroughSignatureList } = this.state;
    let signs = [];
    for (let i = 0; i < walkThroughSignatureList.length; i++) {
      if (i === index) {
      } else {
        signs = [...signs, walkThroughSignatureList[i]];
      }
    }

    // onSetEasyWalkThroughFormData({walkThroughSignatureList:signs})
    this.setState({ walkThroughSignatureList: signs });
  }

  async editServiceRequest(data) {
    const {
      onFetchServiceRequestById,
      onClearServiceRequestDone,
      onFetchServiceRequestTags,
    } = this.props;
    onFetchServiceRequestTags();
    await onClearServiceRequestDone();
    this.setState({ editServiceRequest: true, serviceRequest: data });
    onFetchServiceRequestById(data.id);
  }

  async showImages(data) {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }

  displayImages() {
    const { showImages, selectedImages, selectedIndex } = this.state;
    let type = selectedImages.length === 1 ? 'single' : 'multi';
    let url = selectedImages.length === 1 ? selectedImages[0] : '';
    if (showImages === true) {
      if (type === 'single') {
        return (
          <Lightbox
            open={true}
            close={() => this.setState({ showImages: false })}
            slides={[{ src: url }]}
            plugins={[Zoom]}
          />
        );
      } else {
        return (
          <Lightbox
            open={true}
            close={() => this.setState({ showImages: false })}
            slides={selectedImages.map((image) => ({ src: image }))}
            index={selectedIndex}
            plugins={[Zoom]}
            on={{
              view: ({ index }) => this.setState({ selectedIndex: index }),
            }}
          />
        );
      }
    }
  }
  checkAttachment(data) {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0 ? true : false;
    } else {
      return false;
    }
  }

  deleteServiceRequest = async (data) => {
    this.props.onDeleteServiceRequest(data.id, 'walkthrough');
  };
  render() {
    const {
      onClose,
      onExit,
      headline,
      strapline,
      easyWalkThroughFormData,
      user,
      onSetEasyWalkThroughFormData,
      propertyWalkThroughFormData,
    } = this.props;

    const { showAddForm, firstName, lastName, email, role, showImages } =
      this.state;

    let serviceRequests =
      easyWalkThroughFormData.walkThroughServiceRequests &&
      easyWalkThroughFormData.walkThroughServiceRequests.length > 0
        ? easyWalkThroughFormData.walkThroughServiceRequests
        : [];
    let signatures = this.signatures();

    return (
      <>
        {easyWalkThroughFormData.walkThroughServiceRequestListLoading &&
        easyWalkThroughFormData.walkThroughServiceRequestListLoading ===
          true ? (
          <div style={{ justifyContent: 'center', alignItems: 'center' }}>
            {' '}
            <Loader center={true} />{' '}
          </div>
        ) : (
          <div class="header_section">
            <div class="header_box">
              <div class="header_back_btn">
                <div class="back_arrow" onClick={onClose}>
                  <a href="#.">
                    <svg
                      width="21"
                      height="18"
                      viewBox="0 0 21 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                        fill="#1D1D1D"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="configure_heading">
                <h2>{headline ? headline : ''}</h2>
                <h2>{strapline ? strapline : ''}</h2>
              </div>
              <div class="back_arrow text-right" onClick={onClose}>
                <a href="#.">
                  <svg
                    width="21"
                    height="18"
                    viewBox="0 0 21 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.928968 0.929094C1.16339 0.694674 1.48133 0.562977 1.81285 0.562978C2.14437 0.562978 2.46231 0.694674 2.69673 0.929095L8.00003 6.23239L13.3033 0.929094C13.5377 0.694674 13.8557 0.562978 14.1872 0.562978C14.5187 0.562977 14.8367 0.694674 15.0711 0.929094C15.3055 1.16351 15.4372 1.48146 15.4372 1.81298C15.4372 2.1445 15.3055 2.46244 15.0711 2.69686L9.76779 8.00015L15.0711 13.3034C15.3055 13.5379 15.4372 13.8558 15.4372 14.1873C15.4372 14.5188 15.3055 14.8368 15.0711 15.0712C14.8367 15.3056 14.5187 15.4373 14.1872 15.4373C13.8557 15.4373 13.5377 15.3056 13.3033 15.0712L8.00003 9.76792L2.69673 15.0712C2.46231 15.3056 2.14437 15.4373 1.81285 15.4373C1.48133 15.4373 1.16339 15.3056 0.928968 15.0712C0.694548 14.8368 0.562852 14.5188 0.562852 14.1873C0.562853 13.8558 0.694548 13.5379 0.928969 13.3034L6.23226 8.00015L0.928969 2.69686C0.694548 2.46244 0.562853 2.1445 0.562852 1.81298C0.562852 1.48146 0.694548 1.16351 0.928968 0.929094Z"
                      fill="#1D1D1D"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div className="WalkthroughScroll">
              <div class="itemsCompletedTable">
                <table cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr class="table_head">
                      <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                        {' '}
                        Ticket Number{' '}
                      </th>
                      <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                        {' '}
                        Room{' '}
                      </th>
                      <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                        {' '}
                        Asset{' '}
                      </th>
                      <th> Issue Type </th>
                      <th> Description </th>
                      <th style={{ textAlign: 'center' }}>
                        {' '}
                        <i
                          aria-hidden="true"
                          class="icon fa-paperclip fal f-20"
                        ></i>
                      </th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {serviceRequests && serviceRequests.length > 0
                      ? serviceRequests.map((data) => {
                          return (
                            <tr>
                              <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                {' '}
                                {data.ticketNumber
                                  ? data.ticketNumber
                                  : data && data.ticketId
                                    ? data.ticketId
                                    : ''}
                              </td>
                              <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                {data.areaName
                                  ? data.areaName
                                  : data.area && data.area.name
                                    ? data.area.name
                                    : ''}
                              </td>
                              <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                {data.assetName
                                  ? data.assetName
                                  : data.asset && data.asset.item
                                    ? data.asset?.item?.name
                                    : data.asset
                                      ? data.asset
                                      : ''}
                              </td>
                              <td>
                                {data.serviceType ? data.serviceType : ''}
                              </td>
                              <td>
                                {data.description &&
                                  data.description.substring(
                                    0,
                                    data.description.length > 20
                                      ? '15'
                                      : data.description.length
                                  ) +
                                    (data.description.length < 20 ? '' : '...')}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {this.checkAttachment(data) ? (
                                  <div
                                    className="avatarImgCenter"
                                    onClick={() => this.showImages(data)}
                                  >
                                    <Avatar
                                      badge={
                                        JSON.parse(data.attachment).length > 1
                                          ? 'count'
                                          : ''
                                      }
                                      url={JSON.parse(data.attachment)[0]}
                                    />
                                  </div>
                                ) : (
                                  <img
                                    src="https://via.placeholder.com/640x360"
                                    alt=""
                                  />
                                )}
                              </td>

                              <td class="actionIcons walkThractions">
                                <a
                                  href="#"
                                  onClick={() => this.editServiceRequest(data)}
                                >
                                  <i
                                    aria-hidden="true"
                                    class="icon fa-pencil fal"
                                  ></i>
                                </a>
                                <a
                                  href="#"
                                  onClick={() =>
                                    window.confirm(
                                      `Are you sure you want to delete ${data.ticketId}?`
                                    ) && this.deleteServiceRequest(data)
                                  }
                                >
                                  {' '}
                                  <i
                                    aria-hidden="true"
                                    class="icon fa-trash fal"
                                  ></i>{' '}
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
              {easyWalkThroughFormData.walkthroughChecklistItems &&
                easyWalkThroughFormData.walkthroughChecklistItems.length >
                  0 && (
                  <div class="ChecklistCard walkthroughChecklist">
                    <div class="chack_box_info">
                      <div class="title_chack_box">
                        <h3 className="checklistHead">Walkthrough Checklist</h3>
                      </div>
                      <div class="checklist">
                        <Row>
                          {easyWalkThroughFormData.walkthroughChecklistItems.map(
                            (item, i) => (
                              <Col xs="12" md="3">
                                <div
                                  class="form-check"
                                  style={{ width: '100%' }}
                                >
                                  <Checkbox
                                    label={item.description}
                                    value={item.ischecked}
                                  />
                                </div>
                              </Col>
                            )
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                )}

              <div class="ChecklistCard walkthroughChecklist">
                <div class="chack_box_info">
                  <div class="title_chack_box">
                    <h3 className="checklistHead">Area Checklist</h3>
                  </div>
                  <div class="checklist">
                    <Row>
                      {easyWalkThroughFormData.areaChecklist &&
                      easyWalkThroughFormData.areaChecklist.length > 0 ? (
                        easyWalkThroughFormData.areaChecklist.map((item, i) => (
                          <>
                            {item.walkthroughChecklistItems.length > 0 && (
                              <Col xs="12" md="6">
                                <>
                                  <div className="checklistSubHead checklistmt-2">
                                    {item.name}
                                  </div>
                                  <Row>
                                    {item.walkthroughChecklistItems.map(
                                      (cl) => (
                                        <Col xs="12" md="6">
                                          <div
                                            class="form-check"
                                            style={{ width: '100%' }}
                                          >
                                            <Checkbox
                                              label={cl.description}
                                              value={cl.ischecked}
                                            />
                                          </div>
                                        </Col>
                                      )
                                    )}
                                  </Row>
                                </>
                              </Col>
                            )}
                          </>
                        ))
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ color: '#DFE3E8' }}>
                            <FontAwesomeIcon
                              weight="regular"
                              glyph="info-circle"
                              size="medium"
                            />
                          </div>
                          <div style={{ marginLeft: 10, color: '#919EAB' }}>
                            {'There are currently no area checklists.'}
                          </div>
                        </div>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
              {showImages === true ? <>{this.displayImages()}</> : null}

              <Row>
                {signatures && signatures.length > 0
                  ? signatures.map((data, index) =>
                      data.button === 'Add Signee' ? (
                        <>
                          <Col xs="12" md="6">
                            {showAddForm ? (
                              <div>
                                <div
                                  style={{ paddingLeft: 40, paddingRight: 40 }}
                                >
                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={firstName}
                                        onChange={(e) =>
                                          this.setState({
                                            firstName: e.target.value,
                                          })
                                        }
                                        placeholder="First Name"
                                        block
                                        // errors = {this.state.errors.city}
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={lastName}
                                        onChange={(e) =>
                                          this.setState({
                                            lastName: e.target.value,
                                          })
                                        }
                                        placeholder="Last Name"
                                        block
                                        // errors = {this.state.errors.province}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={role}
                                        onChange={(e) =>
                                          this.setState({
                                            role: e.target.value,
                                          })
                                        }
                                        placeholder="Role"
                                        block
                                        // errors = {this.state.errors.city}
                                      />
                                    </Col>
                                    <Col xs="12" md="6">
                                      <Input
                                        value={email}
                                        onChange={(e) =>
                                          this.setState({
                                            email: e.target.value,
                                          })
                                        }
                                        placeholder="Email Address"
                                        block
                                        // errors = {this.state.errors.province}
                                      />
                                    </Col>
                                  </Row>
                                </div>

                                <SignatureCanvas
                                  onInsert={(url, signType) => {
                                    this.setState({ showOverlay: false });
                                    this.handleSignature(
                                      url,
                                      signType,
                                      index,
                                      null,
                                      'AddNewSignee'
                                    );
                                  }}
                                  firstName={firstName ? firstName : ''}
                                  lastName={lastName ? lastName : ''}
                                  signed=""
                                  signType={1}
                                  typeOfSign={
                                    propertyWalkThroughFormData.walkthroughType
                                  }
                                  permissions={
                                    propertyWalkThroughFormData.permissions
                                      ? propertyWalkThroughFormData.permissions
                                      : ''
                                  }
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  color: '#00848E',
                                  display: 'flex',
                                  height: '35vh',
                                  backgroundColor: 'rgba(214, 207, 207, 0.1)',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: 40,
                                }}
                                onClick={() =>
                                  this.setState({ showAddForm: true })
                                }
                              >
                                <div style={{ paddingRight: 3 }}>
                                  <FontAwesomeIcon glyph="plus-circle" weight="regular" />
                                </div>
                                <div style={{ fontWeight: 600 }}>
                                  {data.button?.toUpperCase()}
                                </div>
                              </div>
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col xs="12" md="6">
                            <Row mdCenter>
                              <Col md="8">
                                <div
                                  style={{
                                    textAlign: 'center',
                                    fontWeight: 700,
                                  }}
                                >
                                  {data.firstName} {data.lastName} {data.role}{' '}
                                  Signature
                                </div>
                              </Col>
                            </Row>

                            <SignatureCanvas
                              onInsert={(url, signType) => {
                                this.handleSignature(
                                  url,
                                  signType,
                                  index,
                                  data
                                );
                              }}
                              signed={
                                data.signature !== '' || data.signature !== null
                                  ? data.signature
                                  : ''
                              }
                              signType={data.signType}
                              remove={() => this.removeSignature(data, index)}
                              firstName={data.firstName ? data.firstName : ''}
                              lastName={data.lastName ? data.lastName : ''}
                              typeOfSign={
                                propertyWalkThroughFormData.walkthroughType
                              }
                              permissions={
                                propertyWalkThroughFormData.permissions
                                  ? propertyWalkThroughFormData.permissions
                                  : ''
                              }
                            />
                          </Col>
                        </>
                      )
                    )
                  : null}
              </Row>

              <div style={{ height: 30 }} />
              <div style={{ textAlign: 'center', marginBottom: 30 }}>
                <Button
                  color="complete_purple"
                  label="Submit"
                  onClick={() => this.handleSubmit()}
                  size="bar"
                  disabled={this.disableButton()}
                />
              </div>
            </div>
          </div>
        )}

        <Overlay
          showOverlay={this.state.editServiceRequest}
          content={
            <ServiceRequestEditForm
              walkThroughSignatureList={
                easyWalkThroughFormData.walkThroughSignatureList
              }
              serviceRequestData={this.state.serviceRequest}
              onClose={(walkThroughSignatureList) => {
                this.setState({
                  editServiceRequest: false,
                  returnFromEditServiceRequest: true,
                });
              }}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let easyWalkThroughFormData = selectEasyWalkThroughFormData(state);
  return {
    easyWalkThroughFormData,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClearServiceRequestDone: clearServiceRequestDone,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,

      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,

      onFetchServiceRequestById: fetchServiceRequestById,
      onDeleteServiceRequest: deleteServiceRequest,
      fetchServiceRequestByIdDone,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onFetchServiceRequestTags: fetchServiceRequestTags,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteWalkthrough);
